import { Fonts, Images } from '../../../shared/theme/';
import styleButton from '../../../shared/components/rbh-button/styles';

export default {
  default: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    height: '100vh',
    backgroundImage: `url(${Images.bg})`,
    backgroundPosition: 'bottom',
    backgroundSize: 'cover',
  }, 
  loginBox: {
    marginTop: 100,
    justifyContent: 'center',
    width: 380,
    height: 466,
    alignItems: 'center',
    backgroundColor: 'white',
    borderRadius: '10px',
    boxShadow: 'rgba(0,0,0,0.2) 0px 2px 4px',
    padding: 40
  },
  iconBox: {
    width: '62.81px',
    height: '24px'
  },
  iconImage: {
    width: '100%',
    height: '100%'
  },
  buttonBox: {
    ...styleButton.buttonGradient,
    width: '100%'
  },
  textInner: {
    ...Fonts.style.textcontentKanitRegularDarkpuple,
    cursor: 'pointer',
    textDecoration: 'underline',
    textAlign: 'center',
    marginTop: 5,
  },
  flexContent: {
    display: 'inline-flex',
    width: '100%',
    justifyContent: 'space-between',
  }
};
